module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"ProjectsName":"Nom des projets","Velocity":"Vélocité","TasksInError":"Nombre de tâches en erreur"}}')
  delete Component.options._Ctor
}
